import React, { useEffect } from 'react';
import LoadingCircle from '../LoadingCircle';

export const IvSignRedirect = ({ error, callback }) => {
    useEffect(callback, []);

    return (
        <div>
            {
                error ? <p>Error: {error}</p> : <LoadingCircle centerVertically />
            }
        </div>
    );
};